/*公共数据 */
import { $http, buildHeaders } from "./index";

//#region 数据字典

//获取客户类型
export const dic_getCustomerType = () => {
  return $http.get("/admin/Dictionary/getCustomerType");
};

//获取客户行业
export const dic_getIndustry = () => {
  return $http.get("/admin/Dictionary/getIndustry");
};

//获取会议日志类型
export const dic_getMeetingLogType = () => {
  return $http.get("/admin/Dictionary/getMeetingLogType");
};

//获取酒店星级
export const dic_getHotelRating = () => {
  return $http.get("/admin/Dictionary/getHotelRating");
};

//获取会议类型
export const dic_getMeetingType = () => {
  return $http.get("/admin/Dictionary/getMeetingType");
};

//获取会议标签
export const dic_getMeetingTag = () => {
  return $http.get("/admin/Dictionary/getMeetingTag");
};

//获取人员类型
export const dic_getConfereeType = () => {
  return $http.get("/admin/Dictionary/getConfereeType");
};

//获取人员标签
export const dic_getConfereeTag = () => {
  return $http.get("/admin/Dictionary/getConfereeTag");
};

//获取车辆类型
export const dic_getCarType = () => {
  return $http.get("/admin/Dictionary/getCarType");
};

//获取新闻类型
export const dic_getNewsType = () => {
  return $http.get("/admin/Dictionary/getNewsType");
};

//获取客户跟进方式
export const dic_getFollowupType = () => {
  return $http.get("/admin/Dictionary/getFollowupType");
};

//获取预算类型
export const dic_getBudgetType = () => {
  return $http.get("/admin/Dictionary/getBudgetType");
};

//获取成本类型
export const dic_getCostType = (params) => {
  return $http.get("/admin/Dictionary/getCostType", {
    params,
  });
};

//获取供应商分类
export const dic_getSupplierType = () => {
  return $http.get("/admin/Dictionary/getSupplierType");
};

//获取付款方式
export const dic_getPaymentType = () => {
  return $http.get("/admin/Dictionary/getPaymentType");
};

//获取办公费用类型
export const dic_getOfficeExpenseType = (params) => {
  return $http.get("/admin/Dictionary/getOfficeExpenseType", {
    params,
  });
};

//获取通知公告类型
export const dic_getAdminNoticeType = () => {
  return $http.get("/admin/Dictionary/getAdminNoticeType");
};

//获取议程嘉宾身份角色
export const dic_getAttendRole = () => {
  return $http.get("/admin/Dictionary/getAttendRole");
};

//获取收款方式
export const dic_getCollectedType = () => {
  return $http.get("/admin/Dictionary/getCollectType");
};

//获取所属单位
export const dic_getBelongUnit = () => {
  return $http.get("/admin/Dictionary/getBelongUnit");
};

//获取计量单位
export const dic_getMeasureUnit = () => {
  return $http.get("/admin/Dictionary/getMeasureUnit");
};

//获取提成比例
export const dic_getCommissionRate = () => {
  return $http.get("/admin/Dictionary/getCommissionRate");
};

//获取飞机舱位
export const dic_getAirlineSeatType = () => {
  return $http.get("/admin/Dictionary/getAirlineSeatType");
};

//获取火车席别
export const dic_getTrainSeatType = () => {
  return $http.get("/admin/Dictionary/getTrainSeatType");
};

//获取接送地点
export const dic_getPickupPlace = () => {
  return $http.get("/admin/Dictionary/getPickupPlace");
};

//获取项目人员角色
export const dic_getServicePersonRole = () => {
  return $http.get("/admin/Dictionary/getServicePersonRole");
};

//#endregion

//#region 公共数据

//获取部门
export const data_getDepartment = (params) => {
  return $http.get("/admin/Data/getDepartment", {
    params,
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取部门
export const data_getDepartment_tree = (params) => {
  return $http.get("/admin/Data/getDepartment", {
    params: { tree: 1, ...params },
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取角色
export const data_getAdminRole = () => {
  return $http.get("/admin/Data/getAdminRole", {
    params: { limit: 0 },
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取用户
export const data_getAdmin_page = (params) => {
  return $http.get("/admin/Data/getAdmin", {
    params: { limit: 0, ...params },
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取管理员及部门
export const data_getAdminDepartment = (params) => {
  return $http.get("/admin/Data/getAdminDepartment", {
    params: { limit: 0, ...params },
    headers: {
      ...buildHeaders(3, "数据加载中，请稍后……"),
    },
  });
};

//获取会议网站报名表单配置
export const data_configMeetingWebsiteSignupForm = () => {
  return $http.get("/admin/Data/configMeetingWebsiteSignupForm", {
    params: {
      limit: 0,
    },
  });
};

//获取结算单位、甲方（客户）列表
export const data_getCustomer = (params) => {
  return $http.get("/admin/Data/getCustomer", {
    params: { limit: 0, ...params },
  });
};

//获取酒店库
export const data_getHotel = (params) => {
  return $http.get("/admin/Data/getHotel", {
    params: { limit: 0, ...params },
  });
};

//获取酒店房型
export const data_getHotelRoomType = (hotel_id, params) => {
  return $http.get("/admin/Data/getHotelRoomType", {
    params: {
      hotel_id,
      limit: 0,
      ...params,
    },
  });
};

//获取酒店宴会厅
export const data_getHotelHall = (hotel_id, params) => {
  return $http.get("/admin/Data/getHotelHall", {
    params: {
      hotel_id,
      limit: 0,
      ...params,
    },
  });
};

//获取会议会场
export const data_getMeetingPlace = (meeting_id, params) => {
  return $http.get("/admin/Data/getMeetingPlace", {
    params: {
      meeting_id,
      limit: 0,
      ...params,
    },
  });
};

//获取人员列表
export const data_getConferee = (params) => {
  return $http.get("/admin/Data/getConferee", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取会议参会人列表
export const data_getMeetingAttendee = (params) => {
  return $http.get("/admin/Data/getMeetingAttendee", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取报账单位、乙方（单位，医院主任）列表
export const data_getBillUnit = (params) => {
  return $http.get("/admin/Data/getBillUnit", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取供应商
export const data_getSupplier = (params) => {
  return $http.get("/admin/Data/getSupplier", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取供应商成本库（供应商常用明细项）列表
export const data_getSupplierCostItem = (params) => {
  return $http.get("/admin/Data/getSupplierCostItem", {
    params: {
      ...params,
    },
  });
};

//获取供应商银行账户列表
export const data_getSupplierBankAccount = (params) => {
  return $http.get("/admin/Data/getSupplierBankAccount", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取成本库列表
export const data_getCostItem = (params) => {
  return $http.get("/admin/Data/getCostItem", {
    params: {
      ...params,
    },
  });
};

//获取银行账户列表
export const data_getBankAccount = (params) => {
  return $http.get("/admin/Data/getBankAccount", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取银行到款列表
export const data_getBankReceipt = (params) => {
  return $http.get("/admin/Data/getBankReceipt", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//获取会议车辆列表
export const data_getMeetingCar = (params) => {
  return $http.get("/admin/Data/getMeetingCar", {
    params: {
      limit: 0,
      ...params,
    },
  });
};

//#endregion
